// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f7532781","977":"14e9c57b"}[chunkId] + ".chunk.js";
};